import { createContext } from 'react';
import type { Org } from '../services/org.service';

export interface OrgContextType {
  org: Org;
  orgId: string;
  orgSlug: string;
  isReadOnly: boolean;
}

export const OrgContext = createContext<OrgContextType | null>(null);
